import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.updateSelectAll()
  }

  selectAll() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true
    })
  }

  clearAll() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
  }

  toggleAll(event) {
    const selectAllCheckbox = event.target
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = selectAllCheckbox.checked
    })
  }

  updateSelectAll() {
    const selectAllCheckbox = document.getElementById('select-all')
    if (!selectAllCheckbox) return

    const allChecked = this.checkboxTargets.every(cb => cb.checked)
    const anyChecked = this.checkboxTargets.some(cb => cb.checked)
    
    selectAllCheckbox.checked = allChecked
    selectAllCheckbox.indeterminate = anyChecked && !allChecked
  }

  confirmDelete(event) {
    const selectedItems = this.checkboxTargets.filter(cb => cb.checked)
    
    if (selectedItems.length === 0) {
      event.preventDefault()
      alert('Please select items to remove.')
      return
    }

    if (!confirm(`Are you sure you want to remove ${selectedItems.length} selected item${selectedItems.length > 1 ? 's' : ''}?`)) {
      event.preventDefault()
    }
  }
}